import { createContext, RefObject } from 'react';

export const LargePanelContext = createContext<RefObject<HTMLDivElement | undefined> | undefined>(undefined);

export default LargePanelContext;
